import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import { useContext } from 'react';

export const UploadFile = ({
  multiple,
  onConfirm,
  acceptedFiles,
  buttonConfigs,
  title,
}) => {
  const { setModal } = useContext(CoreContext);

  return (
    <Button
      small
      mbutton
      nospace
      {...buttonConfigs}
      onClick={() =>
        setModal({
          type: 'upload_file',
          onConfirm,
          multiple,
          acceptedFiles,
        })
      }
    >
      {title ?? 'Anexar'}
    </Button>
  );
};
